export default __webpack_public_path__ + "static/media/home.ff9488fd.svg";